import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import Login from './components/LoginPage/LoginPage';
import Yantra from './components/YantraPage/YantraPage';
import Save from './components/Save/Save';
import About from './components/About/About';
import Details from './components/YantraDetail/YantraDetail';
import DeleteAccount from "./components/DeleteAccountPage/DeleteAccountPage";
import Policy from './components/Policy/Policy';
import Terms from './components/Terms/Terms';
import './App.css';
import './components/HomePage/HomePage.css'


class App extends Component {

  constructor(props) {
    super(props);
    this.state = { isLoading: true }
  }

  componentDidMount() {
    this.loadPage().then(() => this.setState({ isLoading: false }));
  }

  loadPage() {
    return new Promise((resolve) => setTimeout(() => resolve(), 0));
  }

  render() {
      if (this.state.isLoading) {
        return (
            <div className="HomePage" >
              <div className="HomeLogo"></div>
            </div>
        );
      }
      return (
        <Router>
          <div className="App">
            <Route exact path="/" component={Login}/>
            <Route path="/yantra" component={Yantra}/>
            <Route path="/save" component={Save}/>
            <Route path="/about" component={About}/>
            <Route path="/details" component={Details}/>
            <Route path="/delete" component={DeleteAccount}/>
            <Route path="/policy" component={Policy}/>
            <Route path="/terms" component={Terms}/>
          </div>
        </Router>
      );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js